import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import View from './view';

export default class AppConfig extends Component {
    render() {
        const { match } = this.props;
        return (
            <div id="layoutSidenav_content">
                <main>
                    <Switch>
                        <Route path={[`${match.path}/view`]} component={View} />
                    </Switch>
                </main>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/config/index.js